import { useEffect, useMemo, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

import { PayrollDetailsTab } from './PayrollDetailsTab'
import { CompanySettingsTab } from './CompanySettingsTab'
import { CompanyLocationsTab } from './CompanyLocationsTab'
import {
  fetchAllCompanyLocations,
  fetchPayrollCompany,
} from '../payrollActions'
import { Tab, Text, Card } from '@/ui'
import { WorkersCompensationTab } from './WorkersCompensationTab'
import { useAppDispatch } from '@/utils/typeHelpers'
import { TypographyStyles } from '@/styles'
const WC_FEATURE_FLAG = process.env.VITE_WORKERS_COMP_ENABLED

export const PayrollSettings = () => {
  const dispatch = useAppDispatch()
  useEffect(() => {
    dispatch(fetchPayrollCompany())
    dispatch(fetchAllCompanyLocations())
  }, [dispatch])

  const [searchParams] = useSearchParams()

  const [activeIndex, setActiveIndex] = useState(
    searchParams.get('tab') === 'locations' ? 2 : 0
  )
  const panes = useMemo(() => {
    if (WC_FEATURE_FLAG) {
      return [
        {
          menuItem: 'Payroll Details',
          pane: {
            key: 'tab1',
            content: <PayrollDetailsTab />,
            size: 'massive',
          },
        },
        {
          menuItem: 'Company Details',
          pane: {
            key: 'tab2',
            content: (
              <CompanySettingsTab goToLocations={() => setActiveIndex(2)} />
            ),
            size: 'massive',
          },
        },
        {
          menuItem: 'Company Locations',
          pane: {
            key: 'tab3',
            content: <CompanyLocationsTab />,
            size: 'massive',
          },
        },
        {
          menuItem: 'Workers Compensation',
          pane: {
            key: 'tab4',
            content: <WorkersCompensationTab />,
            size: 'massive',
          },
        },
      ]
    } else {
      return [
        {
          menuItem: 'Payroll Details',
          pane: {
            key: 'tab1',
            content: <PayrollDetailsTab />,
            size: 'massive',
          },
        },
        {
          menuItem: 'Company Details',
          pane: {
            key: 'tab2',
            content: (
              <CompanySettingsTab goToLocations={() => setActiveIndex(2)} />
            ),
            size: 'massive',
          },
        },
        {
          menuItem: 'Company Locations',
          pane: {
            key: 'tab3',
            content: <CompanyLocationsTab />,
            size: 'massive',
          },
        },
      ]
    }
  }, [])

  return (
    <div id="payroll-settings">
      <Card>
        <div className="flex flex-col gap-4">
          <Text variant={TypographyStyles.H1}>Payroll Settings</Text>

          <Tab
            panes={panes.map((pane) => ({
              menuItem: pane.menuItem,
              render: () => pane.pane.content,
            }))}
            defaultActiveIndex={activeIndex}
            onTabClick={(index) => setActiveIndex(index)}
          />
        </div>
      </Card>
    </div>
  )
}
